module.exports = {
	"textures": [
		{
			"image": "slotAtlas",
			"format": "RGBA8888",
			"size": {
				"w": 486,
				"h": 82
			},
			"scale": 1,
			"frames": [
				{
					"filename": "btn_closing.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 280,
						"h": 80
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 280,
						"h": 80
					},
					"frame": {
						"x": 1,
						"y": 1,
						"w": 280,
						"h": 80
					}
				},
				{
					"filename": "btn_back_menu.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 100,
						"h": 78
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 100,
						"h": 78
					},
					"frame": {
						"x": 283,
						"y": 1,
						"w": 100,
						"h": 78
					}
				},
				{
					"filename": "btn_back_menu_pressed.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 100,
						"h": 78
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 100,
						"h": 78
					},
					"frame": {
						"x": 385,
						"y": 1,
						"w": 100,
						"h": 78
					}
				}
			]
		}
	],
	"meta": {
		"app": "http://free-tex-packer.com",
		"version": "0.6.7"
	}
};